/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CollectionStatus/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CollectionStatus({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/LedgerTab/Content/Content/CollectionStatus"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let collectionStatusIsHoveredValueData = fromData.useDataValue({ viewPath,
context: 'collection_status',
path: 'is_hovered',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(collectionStatusIsHoveredValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}